import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import { useDispatch } from "react-redux";
import {
  editTranche,
  fetchProjectDetails,
} from "../../../store/slices/projectSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useEffect, useState } from "react";

interface Props {
  form: any;
  setEditDrawerVisible: any;
  editDrawerVisible: boolean;
}

export const TrancheEditDrawer: React.FC<Props> = ({
  setEditDrawerVisible,
  editDrawerVisible,
  form,
}) => {
  const dateFormat = "DD/MM/YYYY";
  const dispatch = useDispatch();
  const { projectDetails } = useSelector((state: RootState) => state.projects);
  const [isEnChantier, setIsEnChantier] = useState(false);

  // Initialize isEnChantier state based on form value when the drawer opens
  useEffect(() => {
    if (editDrawerVisible) {
      const currentPhase = form.getFieldValue("phase_du_projet");
      setIsEnChantier(currentPhase === "en chantier");
    }
  }, [editDrawerVisible, form]);

  const handleValuesChange = (changedValues: any) => {
    if ("phase_du_projet" in changedValues) {
      const isChantier = changedValues.phase_du_projet === "en chantier";
      setIsEnChantier(isChantier);
      
      if (!isChantier) {
        form.setFieldsValue({ etat_avancement: null });
      }
    }
  };

  // Function to handle form submission
  const handleEditSubmit = () => {
    try {
      form.validateFields().then(async (values: any) => {
        // Format dates for submission
        const formattedValues = {
          ...values,
          date_de_permis_de_construire: values.date_de_permis_de_construire
            ? values.date_de_permis_de_construire.format(dateFormat)
            : null,
          date_permis_d_habiter: values.date_permis_d_habiter
            ? values.date_permis_d_habiter.format(dateFormat)
            : null,
        };

        const { id, ...newTranche } = formattedValues;
        console.log("formatted values", formattedValues);

        await dispatch(editTranche({ newTranche, id }));
        await dispatch(fetchProjectDetails(projectDetails.id));
        setEditDrawerVisible(false);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Drawer
      title="Modifier la tranche"
      width={500}
      onClose={() => setEditDrawerVisible(false)}
      open={editDrawerVisible}
      extra={
        <Space>
          <Button onClick={() => setEditDrawerVisible(false)}>Annuler</Button>
          <Button onClick={handleEditSubmit} type="primary">
            Enregistrer
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" name="trancheEditForm" onValuesChange={handleValuesChange}>
        <Form.Item name="id" label="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          name="name"
          label="Nom"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le nom de la tranche",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="date_de_permis_de_construire"
          label="Date permis de construire"
        >
          <DatePicker style={{ width: "100%" }} format={dateFormat} />
        </Form.Item>
        <Form.Item name="date_permis_d_habiter" label="date permis d'habiter">
          <DatePicker style={{ width: "100%" }} format={dateFormat} />
        </Form.Item>

        <Form.Item
          name="surface_fonciere"
          label="Surface foncière"
          rules={[
            {
              required: true,
              message: "Veuillez saisir la surface foncière",
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            type="number"
            addonAfter="m²"
          />
        </Form.Item>
        <Form.Item
          name="surface_construite"
          label="Surface construite"
          rules={[
            {
              required: true,
              message: "Veuillez saisir la surface construite",
            },
          ]}
        >
          <InputNumber
            onChange={(value: any) => {
              // Calculate 75% of surface_construite and set it to surface_vendable
              if (value) {
                const surfaceVendable = Number(value * 0.75).toFixed(2);
                form.setFieldsValue({
                  surface_vendable: surfaceVendable,
                });
              }
            }}
            style={{ width: "100%" }}
            type="number"
            addonAfter="m²"
          />
        </Form.Item>
        <Form.Item
          name="surface_vendable"
          label="Surface vendable"
          rules={[
            {
              required: true,
              message: "Veuillez saisir la surface vendable",
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            type="number"
            addonAfter="m²"
          />
        </Form.Item>

        <Form.Item name="phase_du_projet" label="Phase du projet">
          <Select>
            <Select.Option value="en chantier">En chantier</Select.Option>
            <Select.Option value="en livraison">En livraison</Select.Option>
            <Select.Option value="livré">livré</Select.Option>
          </Select>
        </Form.Item>
        
        {isEnChantier && (
          <Form.Item name="etat_avancement" label="État d'avancement">
            <Select>
              <Select.Option value="Phase étude">Phase étude</Select.Option>
              <Select.Option value="Terrasement">Terrasement</Select.Option>
              <Select.Option value="Viabilisation">Viabilisation</Select.Option>
              <Select.Option value="Gros Oeuvres">Gros Oeuvres</Select.Option>
              <Select.Option value="Finition">Finition</Select.Option>
            </Select>
          </Form.Item>
        )}
      </Form>
    </Drawer>
  );
};